import React from 'react'
import { ProductCare } from '@sainsburys-tech/bolt'
import { Badge } from '@sainsburys-tech/fable'
import * as Styled from './ProductCareWrapper.styles'

const ProductCareWrapper = ({ monthlyCare, ...props }) => {
  const BRAND = process.env.BRAND || 'ARGOS'
  const showMonthlyCareBadge = BRAND.toLowerCase() === 'argos'

  return (
    <Styled.ProductCareWrapper>
      {showMonthlyCareBadge && (
        <Styled.BadgeWrapper>
          <Badge label='2 months free' size='xs' type='red' className='!ds-min-h-0 !ds-text-base' />
        </Styled.BadgeWrapper>
      )}
      <ProductCare.ProductCareItem
        key='monthly-care'
        data-test='monthly-care'
        warrantyPartNumber={monthlyCare.sku}
        warrantyPrice={monthlyCare.price}
        careType={monthlyCare.type}
        {...props}
      />
    </Styled.ProductCareWrapper>
  )
}

export default ProductCareWrapper
